<template>
  <div class="reset-password">
    <div class="d-flex align-center justify-center h-screen">
      <div class="form-container">
        <div class="title">
          <h2>{{ $t("resetPasswordScreen.title") }}</h2>
        </div>
        <div class="reset-password-form">
          <p class="sub-title">
            {{ $t("resetPasswordScreen.subTitleFirst") }}
          </p>
          <v-text-field
            v-model="user.password"
            name="password"
            id="password"
            :label="$t('resetPasswordScreen.passwordPlaceholder')"
            v-on:keyup.enter="isSubmitBtnDisabled ? '' : handleSubmit()"
            autocomplete="new-password"
            browser-autocomplete="new-password"
            @click:append-inner="showPassword = !showPassword"
            :append-inner-icon="showPassword ? 'ti ti-eye-closed' : 'ti ti-eye'"
            :type="showPassword ? 'text' : 'password'"
          ></v-text-field>
          <v-text-field
            v-model="user.password_confirm"
            name="password_confirm"
            id="password_confirm"
            :label="$t('resetPasswordScreen.confirmPasswordPlaceholder')"
            v-on:keyup.enter="isSubmitBtnDisabled ? '' : handleSubmit()"
            autocomplete="new-password"
            browser-autocomplete="new-password"
            @click:append-inner="
              showPassworConfirmAgain = !showPassworConfirmAgain
            "
            :append-inner-icon="
              showPassworConfirmAgain ? 'ti ti-eye-closed' : 'ti ti-eye'
            "
            :type="showPassworConfirmAgain ? 'text' : 'password'"
          ></v-text-field>
          <v-row no-gutters justify="center">
            <v-btn
              type="submit"
              class="send-button"
              @click="handleSubmit"
              :disabled="isSubmitBtnDisabled"
              >{{ $t("resetPasswordScreen.buttons.sendPassword") }}</v-btn
            >
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, sameAs } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { mapActions } from "vuex";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "ResetPasswordScreen",
  components: {},
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      user: {
        password: "",
        password_confirm: "",
      },

      showPassword: false,
      showPassworConfirmAgain: false,
    };
  },
  validations() {
    return {
      user: {
        password: {
          required: required,
        },
        password_confirm: {
          required: required,
          sameAsPassword: sameAs(this.user.password),
        },
      },

      $validationGroups: {
        user: ["user.password", "user.password_confirm"],
      },
    };
  },
  created() {},
  mounted() {},
  computed: {
    isSubmitBtnDisabled() {
      return this.v$.$validationGroups.user.$invalid;
    },
  },
  methods: {
    ...mapActions({
      changePassword: "users/changePassword",
    }),
    handleSubmit() {
      const changePasswordPayload = {
        password: this.user.password,
        code: this.$route.query.code ? this.$route.query.code : "-",
      };
      this.changePassword(changePasswordPayload)
        .then(() => {
          toast.success(this.$t("notifications.success.resetPassword"));
          location.href = "/";
        })
        .catch((err) => {
          this.user.password = "";
          this.user.password_confirm = "";
          toast.error(this.$t(`notifications.error.${err.data.type}`));
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-password {
  width: 100%;
  .form-container {
    background-color: white;
    padding: 32px 16px;
    border-radius: 8px;
    width: 520px;
    box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    .title {
      text-align: center;
      padding: 8px 32px;
      background-color: #ae2f27;
      color: #fff;
      border-radius: 8px;
      margin: -60px auto 0 auto;
      width: fit-content;
    }
    .sub-title {
      font-size: 14px;
      line-height: 1.4;
      margin-bottom: 15px;
    }
    .reset-password-form {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      ::v-deep .v-field {
        padding-right: 0px;
      }
      ::v-deep .v-field__append-inner {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        i {
          opacity: 1;
          &.ti:before {
            font-family: "tabler-icons" !important;
            color: #bebebf;
          }
        }
      }
    }
    .send-button {
      background: #ae2f27;
      color: #fff;
      max-width: 300px;
      padding: 8px 32px;
    }
  }
}

@media (max-width: 756px) {
  .reset-password {
    .form-container {
      width: unset;
    }
    .btn-row {
      flex-direction: column;
      justify-content: space-around;
      gap: 12px;
    }
  }
}
</style>
